import { useTranslation } from 'react-i18next'

import { CatalogModel, ROUTE_TYPE_LABEL_KEYS, RouteModelType } from '../../types'
import { ModelSelectTable } from './ModelSelectTable'

interface RouteTypeSectionProps {
  routeType: RouteModelType
  selection: Map<string, CatalogModel>
  onToggle: (models: CatalogModel[], checked: boolean) => void
}

export function RouteTypeSection({ routeType, selection, onToggle }: RouteTypeSectionProps) {
  const { t } = useTranslation('modelRoute')

  return (
    <div className="flex flex-col gap-4">
      <span className="h6 pl-2 border-l-4 border-secondary">
        {t('create.settingTitle', '{{type}} Route Setting', {
          type: t(ROUTE_TYPE_LABEL_KEYS[routeType], routeType),
        })}
      </span>
      <ModelSelectTable routeType={routeType} selection={selection} onToggle={onToggle} />
    </div>
  )
}
